export default "__VITE_ASSET__d1862c64__"